/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.50
 *
 * Do not edit the class manually.
 *
 */
import { ApiClient } from '../ApiClient';
import { ChecklistPeriodDTO } from './ChecklistPeriodDTO';
import { ChecklistQualitativeAnswerTypeDTO } from './ChecklistQualitativeAnswerTypeDTO';
import { ChecklistStateDTO } from './ChecklistStateDTO';
import { ChecklistTemplateQuantitativeDriverDTO } from './ChecklistTemplateQuantitativeDriverDTO';
import { ControlFunctionDTO } from './ControlFunctionDTO';
import { LegalEntityCompanyDTO } from './LegalEntityCompanyDTO';
import { LegalEntityParentCompanyDTO } from './LegalEntityParentCompanyDTO';
import { LegalEntityRegionDTO } from './LegalEntityRegionDTO';
import { LegalEntitySubsidiaryDTO } from './LegalEntitySubsidiaryDTO';
import { OperationalScopeDTO } from './OperationalScopeDTO';

/**
 * The ChecklistDTO model module.
 * @module model/ChecklistDTO
 * @version v0
 */
export class ChecklistDTO {
  /**
   * Constructs a new <code>ChecklistDTO</code>.
   * @alias module:model/ChecklistDTO
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ChecklistDTO</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ChecklistDTO} obj Optional instance to populate.
   * @return {module:model/ChecklistDTO} The populated <code>ChecklistDTO</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ChecklistDTO();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'Number');
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
      if (data.hasOwnProperty('legalEntityParentCompany'))
        obj.legalEntityParentCompany = LegalEntityParentCompanyDTO.constructFromObject(data['legalEntityParentCompany']);
      if (data.hasOwnProperty('legalEntitySubsidiary'))
        obj.legalEntitySubsidiary = LegalEntitySubsidiaryDTO.constructFromObject(data['legalEntitySubsidiary']);
      if (data.hasOwnProperty('legalEntityCompany'))
        obj.legalEntityCompany = LegalEntityCompanyDTO.constructFromObject(data['legalEntityCompany']);
      if (data.hasOwnProperty('legalEntityRegion'))
        obj.legalEntityRegion = LegalEntityRegionDTO.constructFromObject(data['legalEntityRegion']);
      if (data.hasOwnProperty('checklistState'))
        obj.checklistState = ChecklistStateDTO.constructFromObject(data['checklistState']);
      if (data.hasOwnProperty('checklistPeriod'))
        obj.checklistPeriod = ChecklistPeriodDTO.constructFromObject(data['checklistPeriod']);
      if (data.hasOwnProperty('controlFunction'))
        obj.controlFunction = ControlFunctionDTO.constructFromObject(data['controlFunction']);
      if (data.hasOwnProperty('operationalScopes'))
        obj.operationalScopes = ApiClient.convertToType(data['operationalScopes'], [OperationalScopeDTO]);
      if (data.hasOwnProperty('checklistQualitativeAnswerTypes'))
        obj.checklistQualitativeAnswerTypes = ApiClient.convertToType(data['checklistQualitativeAnswerTypes'], [ChecklistQualitativeAnswerTypeDTO]);
      if (data.hasOwnProperty('checklistTemplateQuantitativeDrivers'))
        obj.checklistTemplateQuantitativeDrivers = ApiClient.convertToType(data['checklistTemplateQuantitativeDrivers'], [ChecklistTemplateQuantitativeDriverDTO]);
      if (data.hasOwnProperty('supervisedEntity'))
        obj.supervisedEntity = ApiClient.convertToType(data['supervisedEntity'], 'Boolean');
      if (data.hasOwnProperty('operativeCompany'))
        obj.operativeCompany = ApiClient.convertToType(data['operativeCompany'], 'Boolean');
      if (data.hasOwnProperty('foreign'))
        obj.foreign = ApiClient.convertToType(data['foreign'], 'Boolean');
      if (data.hasOwnProperty('qualitativeOnly'))
        obj.qualitativeOnly = ApiClient.convertToType(data['qualitativeOnly'], 'Boolean');
      if (data.hasOwnProperty('qualitativeWeight'))
        obj.qualitativeWeight = ApiClient.convertToType(data['qualitativeWeight'], 'Number');
      if (data.hasOwnProperty('quantitativeWeight'))
        obj.quantitativeWeight = ApiClient.convertToType(data['quantitativeWeight'], 'Number');
      if (data.hasOwnProperty('coverage'))
        obj.coverage = ApiClient.convertToType(data['coverage'], 'Number');
      if (data.hasOwnProperty('accuracy'))
        obj.accuracy = ApiClient.convertToType(data['accuracy'], 'Number');
      if (data.hasOwnProperty('fiscalYear'))
        obj.fiscalYear = ApiClient.convertToType(data['fiscalYear'], 'Number');
      if (data.hasOwnProperty('visibleOnBI'))
        obj.visibleOnBI = ApiClient.convertToType(data['visibleOnBI'], 'Boolean');
      if (data.hasOwnProperty('freezeState'))
        obj.freezeState = ApiClient.convertToType(data['freezeState'], 'Boolean');
    }
    return obj;
  }
}

/**
 * @member {Number} id
 */
ChecklistDTO.prototype.id = undefined;

/**
 * @member {String} name
 */
ChecklistDTO.prototype.name = undefined;

/**
 * @member {module:model/LegalEntityParentCompanyDTO} legalEntityParentCompany
 */
ChecklistDTO.prototype.legalEntityParentCompany = undefined;

/**
 * @member {module:model/LegalEntitySubsidiaryDTO} legalEntitySubsidiary
 */
ChecklistDTO.prototype.legalEntitySubsidiary = undefined;

/**
 * @member {module:model/LegalEntityCompanyDTO} legalEntityCompany
 */
ChecklistDTO.prototype.legalEntityCompany = undefined;

/**
 * @member {module:model/LegalEntityRegionDTO} legalEntityRegion
 */
ChecklistDTO.prototype.legalEntityRegion = undefined;

/**
 * @member {module:model/ChecklistStateDTO} checklistState
 */
ChecklistDTO.prototype.checklistState = undefined;

/**
 * @member {module:model/ChecklistPeriodDTO} checklistPeriod
 */
ChecklistDTO.prototype.checklistPeriod = undefined;

/**
 * @member {module:model/ControlFunctionDTO} controlFunction
 */
ChecklistDTO.prototype.controlFunction = undefined;

/**
 * @member {Array.<module:model/OperationalScopeDTO>} operationalScopes
 */
ChecklistDTO.prototype.operationalScopes = undefined;

/**
 * @member {Array.<module:model/ChecklistQualitativeAnswerTypeDTO>} checklistQualitativeAnswerTypes
 */
ChecklistDTO.prototype.checklistQualitativeAnswerTypes = undefined;

/**
 * @member {Array.<module:model/ChecklistTemplateQuantitativeDriverDTO>} checklistTemplateQuantitativeDrivers
 */
ChecklistDTO.prototype.checklistTemplateQuantitativeDrivers = undefined;

/**
 * @member {Boolean} supervisedEntity
 */
ChecklistDTO.prototype.supervisedEntity = undefined;

/**
 * @member {Boolean} operativeCompany
 */
ChecklistDTO.prototype.operativeCompany = undefined;

/**
 * @member {Boolean} foreign
 */
ChecklistDTO.prototype.foreign = undefined;

/**
 * @member {Boolean} qualitativeOnly
 */
ChecklistDTO.prototype.qualitativeOnly = undefined;

/**
 * @member {Number} qualitativeWeight
 */
ChecklistDTO.prototype.qualitativeWeight = undefined;

/**
 * @member {Number} quantitativeWeight
 */
ChecklistDTO.prototype.quantitativeWeight = undefined;

/**
 * @member {Number} coverage
 */
ChecklistDTO.prototype.coverage = undefined;

/**
 * @member {Number} accuracy
 */
ChecklistDTO.prototype.accuracy = undefined;

/**
 * @member {Number} fiscalYear
 */
ChecklistDTO.prototype.fiscalYear = undefined;

/**
 * @member {Boolean} visibleOnBI
 */
ChecklistDTO.prototype.visibleOnBI = undefined;

/**
 * @member {Boolean} freezeState
 */
ChecklistDTO.prototype.freezeState = undefined;

